import { css } from 'emotion';

export namespace styles {
  export const container = css({
    minHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1
  });
}
